// Element.closest polyfill
try {
  const eProto = Element.prototype;
  if (!eProto.closest) {
    eProto.closest = function (css: string) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let node: Element | null = this;
      while (node) {
        if (node.matches(css)) {
          return node;
        } else {
          node = node.parentElement;
        }
      }
      return null;
    };
    console.log('[Polyfills] Element.closest polyfill added.');
  }
} catch (error) {
  console.error('[Polyfills] Unable to polyfill Element.closest', error);
}
